type CustomerNameToIdLookup = {
  [key: string]: number;
};

const playlistCustomers: CustomerNameToIdLookup = {
  deezer: 3,
  amazon: 5,
  amazonUnlimited: 119735,
  pandora: 143537,
  spotify: 1,
  appleMusic: 2,
  yandex: 285183,
  yousee: 287723,
  telmoreMusik: 287724,
  anghami: 285303,
  AmazonAdSupported: 155643,
};

export default playlistCustomers;
